import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN, ORGID } from '@/store/mutation-types'
import EncryUtil from '@/utils/encrypt.js'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  withCredentials: true,
  crossDomain: true,
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 300000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 401) {
      notification.error({
        message: '页面不存在',
        description: data.message
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改

  const orgId = storage.get(ORGID)
  if (token) {
    config.headers['Access-Token'] = token
  }
  if (orgId) {
    config.headers['Access-OrgId'] = orgId
  }
  // if (config.method === 'post') {
  //   if (config.data !== undefined) {
  //     const json = {}
  //     Object.assign(json, config.data)
  //     var key = null
  //     for (key in json) {
  //       if (json[key] !== undefined && json[key] !== [] && json[key] != null) {
  //         const v = json[key]
  //         if (!Array.isArray(v)) {
  //           json[key] = EncryUtil.aesEncrypt(v)
  //         } else {
  //           json[key] = EncryUtil.aesEncrypt(JSON.stringify(v))
  //         }
  //       }
  //     }
  //     config.data = json
  //   }
  //
  //   if (config.params !== undefined) {
  //     const json = {}
  //     Object.assign(json, config.params)
  //     for (key in json) {
  //       if (json[key] !== undefined && json[key] !== [] && json[key] != null) {
  //         const v = json[key]
  //         if (!Array.isArray(v)) {
  //           json[key] = EncryUtil.aesEncrypt(v)
  //         } else {
  //           json[key] = EncryUtil.aesEncrypt(JSON.stringify(v))
  //         }
  //       }
  //     }
  //     config.params = json
  //   }
  // }

  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if (response.data.code === 101) {
    store.dispatch('Logout').then(() => {
      setTimeout(() => {
        window.location.reload()
      }, 10)
    })
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
